import React from 'react'
import { Stack, Box, Divider, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const ItemHeadText = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  color: '#000000DE', //theme.palette.mode === 'dark' ? '#000000DE' : '#fff',
  fontWeight: '500',
  letterSpacing: '0.15px',
  lineHeight: '24px',
  fontSize: '16px',
}))

interface IInstructionExtraPartsHeadProps {
  label?: string
  valueText?: string
}
/**
 * InstructionExtraPartsHead
 *
 * @param __namedParameters IInstructionExtraPartsHeadProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const InstructionExtraPartsHead: React.FC<IInstructionExtraPartsHeadProps> = ({
  label = 'Parts',
  valueText = 'Wrapping Check',
}) => (
  <>
    <Stack
      direction="row"
      divider={<Divider orientation="vertical" flexItem />}
      spacing={2}
      marginX={2}
      padding={2}
      sx={{ backgroundColor: '#F7F7F7' }}
    >
      <Box width={'50%'}>
        <ItemHeadText>{label}</ItemHeadText>
      </Box>
      <Box width={'50%'} marginLeft={2}>
        <Box marginLeft={2}>
          <ItemHeadText>{valueText}</ItemHeadText>
        </Box>
      </Box>
    </Stack>
    <Divider />
  </>
)
